module.exports = __webpack_public_path__ + "static/word-ACCESS-ALL.9024e748.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/festival/word-ACCESS-ALL.png
// module id = 277
// module chunks = 2